import { Component, OnInit} from '@angular/core';
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { TeamGroupsService } from '../../../services/teamGroups.service';
import { ProjectFinancial } from '../../../models/project/ProjectFinancial.model';
import { Consultant } from '../../../models/Consultant.model';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { Json2csvService } from "../../../services/json2csv.service";

@Component({
    selector: 'app-consultants-teamGroups',
    templateUrl: './consultants-teamGroups.component.html',
    styleUrls: ['./consultants-teamGroups.component.css']
})
export class ConsultantsTeamGroupsComponent implements OnInit {
    loading: boolean;
    teamGroups: any;
    dropDownTeamGroups: any;
    projects: ProjectFinancial[] = new Array<ProjectFinancial>();
    dropDownProjects: any;
    consultants: Consultant[] = new Array<Consultant>();
    dropDownConsultant: any;
    consultantsLoad: Consultant[] = new Array<Consultant>();
    teamGroupsSearch: any;
    limit: number = 10;
    itemsPerPage: number[] = [5, 10, 50, 100];
    currentPage: number = 1;
    totalItems: number = 0;
    teamGroupsListing: any;
    teamGroupsListingExport: any;

    constructor(
        private projectsFinancial: ProjectFinancialService,
        private teamGroupsService: TeamGroupsService,
        private localStorage: LocalStorage,
        private json2csvService: Json2csvService
    ) {}

    async ngOnInit() {
        this.loading = true;
        await this.populateTeamGroups();
        await this.populateProjects();
        await this.populateConsultants();
        this.teamGroupsSearch = {};
        this.retrieve();

        await this.search();
        this.loading = false;
    }

    async populateTeamGroups() {
        this.teamGroups = await this.teamGroupsService.getAllTeamGroups();
        this.dropDownTeamGroups = await this.projectsFinancial.createPropertyObjDropDown(this.teamGroups, false, "Times de Consultores", "Times de Consultores");
    }

    async populateProjects() {
        this.projects = await this.projectsFinancial.getAllProjectsFinancial();
        this.dropDownProjects = await this.projectsFinancial.createPropertyObjDropDown(this.projects, false, "Projetos", "projetos");
    }

    async populateConsultants() {
        this.consultantsLoad = await this.projectsFinancial.getAllConsultants();
        this.dropDownConsultant = await this.projectsFinancial.createPropertyObjDropDown(this.consultantsLoad, false, "Consultores", "consultores");
    }

    async search(pg?, exportProjetions?: boolean) {
        this.loading = true;
        this.teamGroupsSearch.limit = this.limit;
        let pageAux = pg ? pg : this.currentPage;
        this.teamGroupsSearch.skip = (pageAux - 1) * this.teamGroupsSearch.limit;
        this.teamGroupsSearch.TeamGroups = [];
        this.teamGroupsSearch.projects = [];
        this.teamGroupsSearch.consultants = [];

        for (let pro of this.dropDownTeamGroups.selectedItems)
          this.teamGroupsSearch.TeamGroups.push(pro.id);

        for (let pro of this.dropDownProjects.selectedItems)
          this.teamGroupsSearch.projects.push(pro.id);

        for (let con of this.dropDownConsultant.selectedItems)
          this.teamGroupsSearch.consultants.push(con.id);

        let res = await this.teamGroupsService.getSearchTeamGroups(this.teamGroupsSearch);
        if(res &&  res.teamGroup) {
            if(!exportProjetions) {
                this.totalItems = res.totalItems;
                this.teamGroupsListing = res;
            } else {
                this.teamGroupsListingExport = res;
            }
        } else {
            this.totalItems = 0;
            this.teamGroupsListing = undefined;
        }

        this.currentPage = pg ? pg : 1;
        this.persist();
        this.loading = false;
    }

    persist() {
        let teamGroups = {
            selectTeamGroups: this.dropDownTeamGroups.selectedItems,
            selectProjects: this.dropDownProjects.selectedItems,
            selectConsultants : this.dropDownConsultant.selectedItems,
        };
        this.localStorage.persist('TeamGroups', teamGroups);
    }

    retrieve(){
        let teamGroups = this.localStorage.retrieve('TeamGroups');
        if(teamGroups){
            this.dropDownTeamGroups.selectedItems = teamGroups.selectTeamGroups;
            this.dropDownProjects.selectedItems = teamGroups.selectProjects;
            this.dropDownConsultant.selectedItems = teamGroups.selectConsultants;
        }
      }

    async export() {
        let csv = [];
        let limitAUX = this.limit;
        this.limit = 99999999999;
        await this.search(1, true);

        this.teamGroupsListingExport.teamGroup.map((group) => {
            let projects = group.projectfinancials.map(project => project.name).join(', ');

            group.consultants.map((consultant) =>  {
                csv.push({
                    'Nome dos Grupos': group.name ? group.name : '-',
                    'Consultores': consultant.name ? consultant.name : '-',
                    'Projetos': projects ? projects : '-'
                });
            });
        });

        this.json2csvService.export(csv, `Grupos de Times - ${new Date().toLocaleDateString('pt-br')}`);
        this.limit = limitAUX;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/consultants-teamGroups/consultants-teamGroups.component.ts